'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];
    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }
  return target;
};
var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }
  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();
var _react = require('react');
var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');
var _propTypes2 = _interopRequireDefault(_propTypes);
var _Tooltip = require('@cimpress/react-components/lib/Tooltip');
var _Tooltip2 = _interopRequireDefault(_Tooltip);
var _reactPlatformTenantSelector = require('@cimpress-technology/react-platform-tenant-selector');
var _reactPlatformTenantSelector2 = _interopRequireDefault(_reactPlatformTenantSelector);
var _lodash = require('lodash.capitalize');
var _lodash2 = _interopRequireDefault(_lodash);
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}
var ProfilePop = function (_Component) {
  _inherits(ProfilePop, _Component);
  function ProfilePop(props) {
    _classCallCheck(this, ProfilePop);
    var _this = _possibleConstructorReturn(this, (ProfilePop.__proto__ || Object.getPrototypeOf(ProfilePop)).call(this, props));
    _this.onCurrentTenantChange = function (tenant) {
      _this.setState({
        selectedTenant: tenant,
        showTenantSelector: false
      });
      _this.props.tenantSelectorProps.onTenantSelected(tenant);
    };
    _this.onShowTenantSelector = function () {
      if (_this.props.tenantSelectorProps && _this.props.tenantSelectorProps.onOpen) {
        _this.props.tenantSelectorProps.onOpen();
      }
      _this.setState({
        showTenantSelector: true,
        open: false
      });
    };
    _this.onHideTenantSelector = function () {
      if (_this.props.tenantSelectorProps && _this.props.tenantSelectorProps.onClose) {
        _this.props.tenantSelectorProps.onClose();
      }
      _this.setState({
        showTenantSelector: false
      });
    };
    _this.state = {
      open: false,
      viewportWidth: 0,
      selectedTenant: null,
      showTenantSelector: false
    };
    _this.updateDimensions = _this.updateDimensions.bind(_this);
    _this.handleClose = _this.handleClose.bind(_this);
    _this.toggle = _this.toggle.bind(_this);
    return _this;
  }
  _createClass(ProfilePop, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      window.addEventListener('resize', this.updateDimensions);
      this.updateDimensions();
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.updateDimensions);
    }
  }, {
    key: 'updateDimensions',
    value: function updateDimensions() {
      this.setState({
        viewportWidth: window.outerWidth
      });
    }
  }, {
    key: 'handleClose',
    value: function handleClose() {
      this.state.open && this.setState({
        open: false
      });
    }
  }, {
    key: 'toggle',
    value: function toggle() {
      this.setState({
        open: !this.state.open
      });
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
        isLoggedIn = _props.isLoggedIn,
        profile = _props.profile,
        onLogInClicked = _props.onLogInClicked,
        onLogOutClicked = _props.onLogOutClicked,
        tenantSelectorProps = _props.tenantSelectorProps,
        authToken = _props.authToken,
        environment = _props.environment;
      var _ref = profile || {},
        email = _ref.email,
        name = _ref.name,
        picture = _ref.picture,
        domain = _ref.domain;
      var _state = this.state,
        selectedTenant = _state.selectedTenant,
        showTenantSelector = _state.showTenantSelector;
      name = name || 'Unknown';
      if (!domain) {
        domain = email ? (0, _lodash2.default)(email.replace(/.*@/, '').split('.')[0]) : '';
      }
      if (!picture) {
        picture = 'https://i2.wp.com/cdn.auth0.com/avatars/' + name[0] + '.png?ssl=1';
      }
      if (!isLoggedIn) {
        return _react2.default.createElement('button', {
          onClick: onLogInClicked,
          className: 'btn btn-outline-secondary btn-sm'
        }, 'Log In');
      }
      var _ref2 = selectedTenant || {},
        tenantLabel = _ref2.label,
        tenantValue = _ref2.value;
      var actingAs = tenantLabel || tenantValue || 'Unknown';
      var profileContents = _react2.default.createElement('div', {
        className: 'text-center'
      }, _react2.default.createElement('div', {
        className: 'popover-content'
      }, _react2.default.createElement('img', {
        className: 'avatar',
        src: picture
      }), _react2.default.createElement('div', {
        style: {
          marginBottom: '5px'
        },
        className: 'username'
      }, name), _react2.default.createElement('div', {
        style: {
          marginBottom: '2px'
        },
        className: 'email'
      }, email), tenantSelectorProps ? _react2.default.createElement('div', null, selectedTenant ? _react2.default.createElement('div', null, 'Acting as:', ' ', _react2.default.createElement('span', {
        className: 'clickable btn-link',
        onClick: this.onShowTenantSelector
      }, actingAs)) : null) : null), _react2.default.createElement('div', {
        className: 'popover-content'
      }, _react2.default.createElement('button', {
        onClick: onLogOutClicked,
        className: 'btn btn-secondary btn-block'
      }, 'Log Out')));
      return _react2.default.createElement('div', {
        className: 'mcp-navbar-userbox'
      }, _react2.default.createElement(_Tooltip2.default, {
        variety: 'popover',
        className: 'user-popover',
        show: this.state.open,
        onClickOutside: this.handleClose,
        direction: 'bottom',
        constraints: [{
          to: 'scrollParent',
          attachment: 'together',
          pin: ['right', 'top']
        }],
        contents: profileContents
      }, _react2.default.createElement(_react.Fragment, null, tenantSelectorProps && isLoggedIn ? _react2.default.createElement(_reactPlatformTenantSelector2.default, _extends({
        authToken: authToken,
        show: showTenantSelector,
        onCurrentTenantChange: this.onCurrentTenantChange,
        resourceType: tenantSelectorProps.tenantType,
        environment: environment,
        onClose: this.onHideTenantSelector
      }, tenantSelectorProps)) : null, _react2.default.createElement('a', {
        className: 'clickable',
        onClick: this.toggle
      }, this.state.viewportWidth > 500 ? _react2.default.createElement('div', null, _react2.default.createElement('div', {
        className: 'username'
      }, name), tenantSelectorProps && selectedTenant ? _react2.default.createElement('div', {
        className: 'organization'
      }, 'Acting as: ', actingAs) : _react2.default.createElement('div', {
        className: 'organization'
      }, domain)) : null, _react2.default.createElement('img', {
        className: 'avatar',
        src: picture
      })))));
    }
  }]);
  return ProfilePop;
}(_react.Component);
exports.default = ProfilePop;
ProfilePop.propTypes = {
  profile: _propTypes2.default.shape({
    email: _propTypes2.default.string,
    name: _propTypes2.default.string,
    picture: _propTypes2.default.string,
    domain: _propTypes2.default.string,
    sub: _propTypes2.default.string
  }),
  onLogOutClicked: _propTypes2.default.func.isRequired,
  onLogInClicked: _propTypes2.default.func.isRequired,
  isLoggedIn: _propTypes2.default.bool,
  tenantSelectorProps: _propTypes2.default.shape({
    tenantType: _propTypes2.default.string,
    onTenantSelected: _propTypes2.default.func,
    onOpen: _propTypes2.default.func,
    onClose: _propTypes2.default.func,
    show: _propTypes2.default.bool
  })
};